import * as yup from "yup";

import { IRefundPaymentIssueToCustomer } from "../../../../interfaces-and-types";

export const refundPaymentIssueToCustomerSchema: yup.SchemaOf<IRefundPaymentIssueToCustomer> =
  yup
    .object({
      transfer_refund_id: yup
        .string()
        .required("Please provide the transfer refund id"),
      account_number: yup.string().nullable().optional(),
      bank_code: yup.string().nullable().optional(),
      description: yup.string().nullable().optional().max(300),
    })
    .required();
